/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Annotation({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#Annotation_svg__clip0_390_2567)"><path fill="currentColor" d="M4.8 14.4a.6.6 0 0 1 0 1.2H4a.6.6 0 1 1 0-1.2zm4 0a.6.6 0 0 1 0 1.2H7.2a.6.6 0 1 1 0-1.2zm3.2 0a.6.6 0 0 1 0 1.2h-.8a.6.6 0 1 1 0-1.2zm1-14A2.6 2.6 0 0 1 15.6 3v7.188a2.6 2.6 0 0 1-2.6 2.6H3a2.6 2.6 0 0 1-2.6-2.6V3A2.6 2.6 0 0 1 3 .4zM3 1.6A1.4 1.4 0 0 0 1.6 3v7.188a1.4 1.4 0 0 0 1.4 1.4h10c.774 0 1.4-.627 1.4-1.4V3c0-.773-.626-1.4-1.4-1.4zm5 3.61a.6.6 0 0 1 .6.6v3.356h1.158a.6.6 0 1 1 0 1.2H6.242a.6.6 0 1 1 0-1.2H7.4V6.409h-.72a.6.6 0 0 1 0-1.199zm0-2.439A.84.84 0 1 1 8 4.453.84.84 0 0 1 8 2.77" /></g></svg>;
}
;